/** Minimalfelder für „Gast physisch vor Ort“ (eingecheckt, Anreise erreicht, noch nicht ausgecheckt). */
export type GuestOnSiteBooking = {
  status: string;
  arrival_date: string;
};

/**
 * Eingecheckter Gast gilt als vor Ort bis zum Check-out – auch am Abreisetag und bei
 * überfälliger Abreise (departure_date in der Vergangenheit).
 *
 * Entspricht der Platz-Belegung in Dashboard und Statistik: physisch belegt erst nach
 * Check-in, wieder frei erst nach Check-out.
 */
export function isGuestCheckedInOnSite(
  booking: GuestOnSiteBooking,
  referenceDate: string,
): boolean {
  return booking.status === "checked_in" && booking.arrival_date <= referenceDate;
}

/** Summe Erwachsene + Kinder für eingecheckte Gäste vor Ort. */
export function countGuestsCheckedInOnSite(
  bookings: Array<GuestOnSiteBooking & { adults?: number | null; children?: number | null }>,
  referenceDate: string,
): number {
  return bookings
    .filter((b) => isGuestCheckedInOnSite(b, referenceDate))
    .reduce((sum, b) => sum + (b.adults ?? 0) + (b.children ?? 0), 0);
}

/** Summe gemeldeter Hunde für eingecheckte Buchungen vor Ort. */
export function countDogsCheckedInOnSite(
  bookings: Array<GuestOnSiteBooking & { dogs?: number | null }>,
  referenceDate: string,
): number {
  return bookings
    .filter((b) => isGuestCheckedInOnSite(b, referenceDate))
    .reduce((sum, b) => sum + (b.dogs ?? 0), 0);
}
